module.exports = __webpack_public_path__ + "static/media/Тезисы УОМШ-2025. Том 2.d85910a7.pdf";